import { RouteRecordRaw } from "vue-router";

import DummyRouterView from "@/components/structure/DummyRouterView.vue";
import usePermissions from "@/hooks/use-permissions";
import ActionLogsListPage from "@/pages/games/GameDisplay/children/actionlogs/ActionLogsList/ActionLogsListPage.vue";
import VersionHistoryListPage from "@/pages/games/GameDisplay/children/versionHistory/VersionHistoryListPage.vue";
import VersionHistoryPage from "@/pages/games/GameDisplay/children/versionHistory/VersionHistoryPage.vue";

import links from "./links";

const { canReadActionlogs } = usePermissions();

export default <RouteRecordRaw[]>[
  {
    path: "",
    component: ActionLogsListPage,
    name: links.games.actionLogs,
    props: true,
    meta: {
      title: "Action logs",
      permission: canReadActionlogs,
    },
  },
  {
    path: "version-history",
    component: DummyRouterView,
    props: true,
    children: [
      {
        path: "",
        component: VersionHistoryListPage,
        name: links.games.versionHistoryList,
        props: true,
        meta: {
          title: "Version history",
          permission: canReadActionlogs,
        },
      },
      {
        path: ":baseVersionId/:targetVersionId",
        component: VersionHistoryPage,
        name: links.games.versionHistoryDetail,
        props: true,
        meta: {
          title: "Version history",
          permission: canReadActionlogs,
        },
      },
    ],
  },
];
